import { Checkbox, MenuItem, Typography } from "@mui/material";
import SvgToIcon from "../../../icons/SvgToIcon";

const FilterMenuItem = ({ checked, onToggle, icon, text, colors }) => (
  <MenuItem
    onClick={onToggle}
    disableRipple
    sx={{
      display: "flex",
      alignItems: "center",
      padding: "8px 4px",
      "&:hover": {
        backgroundColor: "transparent",
      },
    }}
  >
    <Checkbox
      checked={checked}
      size="small"
      sx={{
        padding: "0",
        marginRight: "8px",
        "& .MuiSvgIcon-root": {
          fontSize: "16px",
        },
      }}
    />
    {icon && (
      <SvgToIcon
        IconLogo={icon}
        style={{
          width: "16px",
          height: "16px",
          marginRight: "8px",
        }}
      />
    )}
    <Typography
      variant="caption"
      sx={{
        color: colors.text_primary,
      }}
    >
      {text}
    </Typography>
  </MenuItem>
);

export default FilterMenuItem;
